import { useInvalidateQuery as useInvalidateGetNotificationQuery } from "@faire/web-api--source/api/retailer/notifications/get-hooks";
import { useEffect, useRef } from "react";
import { useZustandLocation } from "@faire/retailer-visitor-shared/app/_lib/routing/useZustandLocation";
import { forceRefetchAlertBannerRoutes } from "@faire/retailer/packages/core/services/AlertBanner/consts";
export var useNotificationRefetch = function() {
    var invalidateGetNotificationQuery = useInvalidateGetNotificationQuery();
    var pathname = useZustandLocation(function(state) {
        return state.pathname;
    }).pathname;
    var prevRoute = useRef("");
    var shouldForceRefetchNotifications = function(routes) {
        return routes.some(function(route) {
            return forceRefetchAlertBannerRoutes.includes(route);
        });
    };
    useEffect(function() {
        if (shouldForceRefetchNotifications([
            pathname,
            prevRoute.current
        ])) {
            invalidateGetNotificationQuery();
        }
        // Update the previous route after the check
        prevRoute.current = pathname;
    }, [
        pathname,
        invalidateGetNotificationQuery
    ]);
};
